import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import _ from "lodash";
import LocaleStrings from "@language";

const ThankYou = (props) => {
  const { eventData } = props;

  const closeAlert = () => {
    props.close();
  };

  return (
    <div className="mt-6">
      <div className="rounded-md border border-green-300 bg-green-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <CheckCircleIcon
              className="h-6 w-6 text-green-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <div className="text-xl font-semibold text-green-700">
              {LocaleStrings.kAbstractSuccessTitleText}
            </div>
            <div className="text-base font-normal text-green-600 break-words my-3">
              {LocaleStrings.kAbstractSuccessDescText}
            </div>
            <div className="text-sm font-normal text-green-600 text-right">
              {_.replace(
                LocaleStrings.kAbstractEventTeamText,
                "#eventname",
                eventData?.eventname
              )}
            </div>
          </div>
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                className="inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 hover:border hover:border-green-300 focus:outline-none"
                onClick={closeAlert}
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
